import React, { useCallback, useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Privilege, AccountType } from '../../api';
import useMe from '../Util/useMe';
import Progress from '../Util/Progress';
import { RouteComponentProps, withRouter } from 'react-router';
import AccountDetail from './AccountDetail';
import AccountSidemenu from './AccountSidemenu';
import accountService from '../../services/accounts';
import useHasPrivilege from '../Util/useHasPrivilege';
import tokenProvider from '../../utils/token';

type TParams = { account?: string };
interface Props extends RouteComponentProps<TParams> {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const Container1 = styled.div`
  height: 100%;
`;

const Container2 = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: inline-block;
`;

const AccountOverview: React.FunctionComponent<Props> = (props) => {
  const { data } = useMe();
  const [account, setAccount] = useState<any>();
  const [accounts, setAccounts] = useState<any>([]);
  const [types, setTypes] = useState<any>(['CUSTOMER', 'LABELLING']);
  const [search, setSearch] = useState<any>();
  const [initial, setInitial] = useState(true);
  const debounceTimeout = useRef<any>();
  const isAdmin = useHasPrivilege(Privilege.Admin);

  const getAccount = useCallback(async (accountId) => {
    const result = await accountService.getAccount(accountId);
    setAccount(result);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountService]);

  useEffect(() => {
    if (accounts.length === 0) {
      return;
    }

    if (props.match.params.account === 'new') {

      setAccount({
        id: '',
        name: '',
        accountType: AccountType.Customer
      });

      return;
    }
    
    const accountId = (isAdmin ? props.match.params.account : tokenProvider.getParsedToken().account_id) || tokenProvider.getParsedToken().account_id;

    if (accountId) {
      getAccount(accountId);
    }


  }, [isAdmin, setAccount, accounts, props.match.params.account, getAccount])

  useEffect(() => {
    if (!data) {
      return;
    }

    if (!props.match.params.account) {
      props.history.push('/account/' + data.me?.account?.id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.account , data ])

  const getAccounts = useCallback(async () => {

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    const time = initial ? 1 : 300;

    debounceTimeout.current = setTimeout(async () => {
      const { items} = await accountService.getAccounts({ search, types, limit: 1000 });
      setAccounts(items);
      setInitial(false);
    }, time)
  }, [search, types, setAccounts, debounceTimeout, initial]);

  useEffect(() => {
    getAccounts();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountService, search, types])

  const onSearch = useCallback((value) => {
    setSearch(value);
  }, [setSearch]);

  const onChangeTypes = useCallback((value) => {
    setTypes(value);
  }, [setTypes]);

  const onAddAccount = useCallback((newAccount) => {
    const newAccounts = [...accounts];

    newAccounts.unshift(newAccount);

    setAccounts(newAccounts);

    props.history.push('/account/' + newAccount.id);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accounts, setAccounts]);

  if (!data?.me?.roles) {
    return ( <Wrapper>
      <Container1>
        <Progress />
      </Container1>
      </Wrapper>);
  }

  return (
    <Wrapper>
      <Container1>
        <AccountSidemenu search={search} types={types} onSearch={onSearch} onChangeTypes={onChangeTypes} accounts={accounts} />
      </Container1>
       <Container2>{account ? <AccountDetail account={account} onAddAccount={onAddAccount} /> : <Progress />}</Container2> 
    </Wrapper>
  );
};

export default withRouter(AccountOverview);
